import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { RequestTeacherPayoutBody } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const teacherRequestTeacherPayout = createApiThunk<void, RequestTeacherPayoutBody>(
  "payouts/teacherTriggerTeacherPayout",
  async (command: RequestTeacherPayoutBody, { extra: { teacherRepository } }) => {
    await teacherRepository!.requestTeacherPayout(command);
  },
);

export const resetTeacherRequestTeacherPayout = createAction("payouts/resetTeacherRequestTeacherPayout");
